"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const commonManifestDomain = "app-manifest.leadconnectorhq.com";
const createManifestPaths = (env) => ({
    latest: `https://${env}.${commonManifestDomain}/latest/manifest.json`,
    fallback: `https://${env}.${commonManifestDomain}/fallback/manifest.json`,
});
const manifestPathsByEnv = {
    staging: createManifestPaths('staging'),
    production: createManifestPaths('production'),
    interop: createManifestPaths('interop'),
    alpha: createManifestPaths('alpha'),
    beta: createManifestPaths('beta'),
};
const getManifestDomain = (nodeEnv, manifestURL) => {
    if (manifestURL) {
        return {
            latest: manifestURL,
            fallback: manifestURL
        };
    }
    if (!Object.keys(manifestPathsByEnv).includes(nodeEnv)) {
        return manifestPathsByEnv['production'];
    }
    return manifestPathsByEnv[nodeEnv];
};
exports.default = getManifestDomain;
//# sourceMappingURL=manifest-domains.js.map